import { defineMessages } from 'react-intl';
import labels from 'utils/labels';

export default defineMessages({
  contractIncorrect: {
    id: 'toaster.contract_incorrect',
  },
  errorToaster: {
    id: 'toaster.service_error',
  },
  policyNumberAlreadyBeenAdded: {
    id: 'toaster.policy_number_already_been_added',
  },
  defaultErrorMessage: {
    id: 'toaster.default_error_message',
  },
  currentPasswordIncorrect: {
    id: 'toaster.current_password_incorrect',
  },
  passwordSuccessfullyChanged: {
    id: 'toaster.password_successfully_changed',
  },
  secretQuestionSuccessfullyChanged: {
    id: 'toaster.secret_question_successfully_changed',
  },
  bugSuccessfullyReported: {
    id: 'toaster.bug_successfully_reported',
  },
  profileSettingsSuccessfullyUpdated: {
    id: 'toaster.profile_settings_successfully_updated',
  },
  actionCompletedSuccessfully: {
    id: 'toaster.action_completed_successfully',
  },
  sessionExpired: {
    id: 'toaster.session_expired',
  },
  emailAlreadyExist: {
    id: 'toaster.email_already_exist',
  },
  accountAlreadyExist: {
    id: 'toaster.account_already_exist',
  },
  newEmailSent: {
    id: 'toaster.newEmailSent',
  },
  pinIncorrect: {
    id: 'toaster.pinIncorrect',
  },
  serviceUnavailable: {
    id: 'toaster.service_unavailable',
  },
  signupFailed: {
    id: 'toaster.service_unavailable',
  },
  userNotFound: {
    id: 'recovery_forgot_login.Infos',
  },
  [labels.addNewContractNotFountAMC]: {
    id: labels.addNewContractNotFountAMC,
  },
});
